import { createSlice } from "@reduxjs/toolkit";

const loadFromLocalStorage = () => {
  const savedState = localStorage.getItem("galleryState");

  return savedState ? JSON.parse(savedState) : null;
};

const initialState = loadFromLocalStorage() || {
  galleries: null,
  isPhotoTourScreen: false,
  focusedIdx: null,
  items: [],
  selectedId: null,
};

const saveToLocalStorage = (state) => {
  localStorage.setItem("galleryState", JSON.stringify(state));
};

export const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    setGalleries: (state, action) => {
      state.galleries = action.payload;
      saveToLocalStorage(state); // Save to local storage
    },
    setIsPhotoTourScreen: (state, action) => {
      state.isPhotoTourScreen = action.payload;
      saveToLocalStorage(state); // Save to local storage
    },
    setFocusedPhotoIdx: (state, action) => {
      state.focusedIdx = action.payload;
      saveToLocalStorage(state); // Save to local storage
    },
    setBadgeSwitchPhotos: (state, action) => {
      state.items = action.payload;
      saveToLocalStorage(state); // Save to local storage
    },
    setSelectedPhotoSwitchId: (state, action) => {
      state.selectedId = action.payload;
      saveToLocalStorage(state); // Save to local storage
    },
  },
});

export const getGalleries = (state) => state.gallery.galleries;
export const selectIsPhotoTourScreen = (state) => state.gallery.isPhotoTourScreen;
export const selectFocusedPhotoIdx = (state) => state.gallery.focusedIdx;
export const getBadgeSwitchPhotos = (state) => state.gallery.items;
export const getSelectedBadgePhotoId = (state) => state.gallery.selectedId;

export const getSelectedBadgePhoto = (state) => {
  const items = state.gallery.items;
  const selectedId = state.gallery.selectedId;

  if (!items.length || !selectedId) {
    return null;
  }

  return items.find((item) => item.id === selectedId);
};

export const selectFocusedPhotos = (state) => {
  const galleries = state.gallery.galleries;
  const focusedBadgeSwitchItem = state.gallery.selectedId;

  const key = Object.keys(galleries || {}).find((v) => v.toLowerCase() === focusedBadgeSwitchItem);

  return galleries[key];
};

export const selectFocusedPhoto = (state) => {
  const focusedPhotos = selectFocusedPhotos(state);

  if (!focusedPhotos || !Object.keys(focusedPhotos || {}).length) {
    return;
  }

  const focusedIdx = selectFocusedPhotoIdx(state);

  return focusedPhotos[focusedIdx] || focusedPhotos[0];
};

export const getFocuedIndex = (state) => state.gallery.focusedIdx;

export const { setGalleries, setIsPhotoTourScreen, setFocusedPhotoIdx, setBadgeSwitchPhotos, setSelectedPhotoSwitchId } = gallerySlice.actions;

export default gallerySlice.reducer;
